import api from '@/utils/api';
import { NotificationManager } from 'react-notifications';
import { FETCH_SCHEDULE_AREA_FUNCTIONS, FETCH_SCHEDULE_AREA_FUNCTION } from './types';

const showScheduleAreaFunctionError = (error) => {
    NotificationManager.error(error.response?.data?.msg || 'Không thể xử lý chức năng khu vực.');
};

export const fetchScheduleAreaFunctions = (filters = {}) => dispatch => api
    .get('/schedule-area-functions', { params: filters })
    .then(res => {
        dispatch({ type: FETCH_SCHEDULE_AREA_FUNCTIONS, payload: res.data.data });
        return res.data;
    })
    .catch(error => {
        showScheduleAreaFunctionError(error);
        return Promise.reject(error);
    });

export const fetchScheduleAreaFunction = id => dispatch => api
    .get(`/schedule-area-functions/${id}`)
    .then(res => {
        dispatch({ type: FETCH_SCHEDULE_AREA_FUNCTION, payload: res.data.data });
        return res.data.data;
    })
    .catch(error => {
        showScheduleAreaFunctionError(error);
        return Promise.reject(error);
    });

export const createScheduleAreaFunction = data => () => api
    .post('/schedule-area-functions', data)
    .then(res => {
        NotificationManager.success(res.data.msg);
        return res.data.data;
    })
    .catch(error => {
        showScheduleAreaFunctionError(error);
        return Promise.reject(error);
    });

export const updateScheduleAreaFunction = (id, data) => () => api
    .put(`/schedule-area-functions/${id}`, data)
    .then(res => {
        NotificationManager.success(res.data.msg);
        return res.data.data;
    })
    .catch(error => {
        showScheduleAreaFunctionError(error);
        return Promise.reject(error);
    });

export const removeScheduleAreaFunctions = ids => () => api
    .delete('/schedule-area-functions', { data: { ids } })
    .then(res => {
        NotificationManager.success(res.data.msg);
        return res.data;
    })
    .catch(error => {
        showScheduleAreaFunctionError(error);
        return Promise.reject(error);
    });
